'use client';

import Script from 'next/script';

import { getENV } from '../../utils/env';
import { useMedalliaDefaultButton } from './hooks';

import './MedalliaScript.scss';

export const MedalliaLegacy = () => {
    const { NEXT_PUBLIC_MEDALLIA_ID_US, NEXT_PUBLIC_MEDALLIA_ID_CA, NEXT_PUBLIC_LOCALE } = getENV();
    const isCA = NEXT_PUBLIC_LOCALE === 'en-CA';
    const scriptId = isCA ? NEXT_PUBLIC_MEDALLIA_ID_CA : NEXT_PUBLIC_MEDALLIA_ID_US;

    useMedalliaDefaultButton();

    return (
        <Script
            async
            data-testid="medallia-script"
            src={`https://resources.digital-cloud.medallia.com/wdcus/${scriptId}/onsite/embed.js`}
        />
    );
};
